import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

function FAQItem({
  title,
  content,
  baseClassName = "FrequentlyAskedQuestions",
  event,
}) {
  const [open, setOpen] = useState(false);

  const toggleState = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    if (open && event) {
      event("seeFAQs");
    }
  }, [open, event]);

  const faqItemClassName = classNames(`${baseClassName}-item`, { open });

  return (
    <article className={faqItemClassName}>
      <h4 className={`${baseClassName}-item-title`}>
        <a className={`${baseClassName}-item-title-text`} onClick={toggleState}>
          {title}
        </a>
      </h4>
      <div
        className={`${baseClassName}-item-content`}
        // eslint-disable-next-line
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </article>
  );
}

FAQItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  baseClassName: PropTypes.string,
  event: PropTypes.func,
};

export default FAQItem;
